import axios from 'axios';
export async function getMaintenancePlanning(token) {
    const res = await axios.get('/api/Planning/GetMaintenancePlanning', getHeaders(token));
    try {

        for (let i = 0; i < res.data.length; i++) {
                res.data[i].startDate = new Date(res.data[i].startDate);
                res.data[i].endDate = new Date(res.data[i].endDate);
        }
        return res.data;
    }
    catch {
        return res;
    }
}

export async function getQuotes(token) {
    const res = await axios.get('/api/WorkTask/GetQuotes', getHeaders(token));
    try {
        return res.data;
    }
    catch {
        return res;
    }
}

export async function updateContract(token, contractOid, maintenancePlanned, lastMaintenanceDate) {
    return await axios.patch(`/api/Contract/Patch/${contractOid}`, {
        LastMaintenanceDate: lastMaintenanceDate ? new Date(lastMaintenanceDate).toISOString() : undefined,
        MaintenancePlanned: maintenancePlanned,
    }, getHeaders(token));
}

export async function createOpdracht(tokenWerkbonIQPlatform, opdracht_omschrijving, opdracht_opmerkingen,
    opdracht_datum, werkzaamheden, status, medewerker, klant, opdracht_allday, visibleInApp, opdracht_einddatum, contractId) {

    return await axios.post(`${process.env.REACT_APP_WERKBONNEN_URL}/opdracht`, {
        opdracht_omschrijving, opdracht_opmerkingen,
        opdracht_datum, werkzaamheden, status, medewerker, klant, opdracht_allday, visibleInApp, opdracht_einddatum, contractId
    }, getWerkbonnenHeaders(tokenWerkbonIQPlatform));

}

export async function getMedewerkerList(tokenWerkbonIQPlatform) {
    const res = await axios.get(`${process.env.REACT_APP_WERKBONNEN_URL}/medewerkers/getMedewerkers/`, getWerkbonnenHeaders(tokenWerkbonIQPlatform));
    try {

        return res.data;
    }
    catch {
        return res;
    }
}

export async function getKlantenSimpel(tokenWerkbonIQPlatform) {
    const res = await axios.get(`${process.env.REACT_APP_WERKBONNEN_URL}/klant/findAllKlanten/`, getWerkbonnenHeaders(tokenWerkbonIQPlatform));
    try {
        return res.data;
    }
    catch {
        return res;
    }
}

const getHeaders = (token) => {
    return {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        }
    };
};

const getWerkbonnenHeaders = (tokenWerkbonIQPlatform) => {
    return {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${tokenWerkbonIQPlatform}`
        }
    };
};
